export interface IFormKey {
    id: string;
    controlName: string;
    label: string;
    type?: TFormType;
    css?: string;
    options?: IFormSelectOption[];
    readonly?: boolean;
    hidden?: boolean;
    defaultValue?: string;
    maxDate?: any;
    minDate?: any;
    uppercase?: boolean;
    isInternal?: boolean;
    isAmountField?: boolean;
    wrapOptions?: boolean;
    action?: (...params: any[]) => any;
    numberMin?: number;
    numberMax?: number;
    alreadyExistsInRegistry?: boolean;
}

export interface IFormSelectOption {
    key: any;
    value: any;
    disabled?: boolean;
    valueForMapping?: any;
    additionalData?: any;
}

export enum EFormType {
    INPUT = 'INPUT',
    NUMBER = 'NUMBER',
    DATEPICKER = 'DATEPICKER',
    SELECT = 'SELECT',
    TEXTAREA = 'TEXTAREA',
    RADIO = 'RADIO',
    TOGGLE = 'TOGGLE',
    CHECKBOX = 'CHECKBOX',
    MULTIPLE_SELECT = 'MULTIPLE_SELECT',
    NEW_LINE = 'NEW_LINE',
    BUTTON = 'BUTTON'
}

export type TFormType = keyof typeof EFormType;

export enum ERadioValue {
    TRUE = '1',
    FALSE = '0'
}
